import { createAction } from '@reduxjs/toolkit'
import { Month } from 'shared/DateUtils'
import { SegmentList } from '../Shared/helperFunctions'
import { ProgramsType, CurrencyType } from '../Shared/types'
import { LaunchProgramsState } from './launchProgramsSlice'
import { grhType, micromobilityType, flexType, qtfType } from '../Shared/types'

const changeSelectedDate = createAction<Month | null>(
  'launchPrograms/changeSelectedDate'
)

const changeSelectedSegments = createAction<SegmentList[]>(
  'launchPrograms/changeSelectedSegments'
)

const changeSelectedPrograms = createAction<ProgramsType[]>(
  'launchPrograms/changeSelectedPrograms'
)

const changeProgramName = createAction<string>(
  'launchPrograms/changeProgramName'
)

const changeDescription = createAction<string>(
  'launchPrograms/changeDescription'
)

const changeCurrency = createAction<CurrencyType>(
  'launchPrograms/changeCurrency'
)

const incompleteLaunch = createAction<boolean>(
  'launchPrograms/incompleteLaunch'
)

const fetchDraftProgramState = createAction<LaunchProgramsState>(
  'launchPrograms/fetchDraftProgramState'
)

const saveDraftProgramState = createAction<{
  selectedDate: Month
  selectedPrograms: ProgramsType[]
  selectedSegments: SegmentList[]
  programName: string
  description: string
  currency: CurrencyType
  grh: grhType
  qtf: qtfType
  micromobility: micromobilityType
  flex: flexType
}>('launchPrograms/saveDraftProgramState')

const deleteDraftProgramState = createAction(
  'launchPrograms/deleteDraftProgramState'
)

const applyRehydrateState = createAction<any>(
  'launchPrograms/applyRehydrateState'
)

const clearStateForNewLaunch = createAction(
  'launchPrograms/clearStateForNewLaunch'
)

export const launchProgramsActions = {
  changeSelectedDate,
  changeSelectedSegments,
  changeSelectedPrograms,
  changeProgramName,
  changeDescription,
  changeCurrency,
  incompleteLaunch,
  fetchDraftProgramState,
  saveDraftProgramState,
  deleteDraftProgramState,
  applyRehydrateState,
  clearStateForNewLaunch,
}
